<script>
  import { checkbox } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';

  export default {
    components: { checkbox, Radio },
    props: {
      solicitacao: Object,
      edicao: Boolean
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      labelmensagemFinalSalvar() {
        var msg = 'Mensagem de conclusão ao salvar uma ';

        if (this.solicitacao.tipoSolicitacao == 4)
          msg += ' doação.';
        else
          msg += ' inscrição';

        return msg;
      }
    },
    methods: {
      validarDadosSolicitacao() {
        return this.$validator.validateAll();
      },
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .infoSol {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
        <div class="required">
          <label class="control-label" for="cadastroCompleto">Cadastro completo <i class="fa fa-info-circle infoSol" v-tooltip="'Se SIM, será necessário informar o endereço no cadastro das inscrições\\doações.'"></i></label>
        </div>

        <div class="form-group required">
          <radio v-model="solicitacao.cadastroCompleto"
                 :selected-value="1"
                 type="success"
                 :inline="true"
                 data-vv-name="cadastroCompleto"
                 class="margin-right-10"
                 :class="[true ? '' : 'radioLeft']">
            Sim
          </radio>
          <radio v-model="solicitacao.cadastroCompleto"
                 :selected-value="0"
                 data-vv-name="cadastroCompleto"
                 type="success"
                 :inline="true">
            Não
          </radio>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('siteCursoEvento')}">
          <label class="control-label" for="documento">Site</label>

          <input type="text"
                 class="form-control"
                 id="descricao"
                 v-model="solicitacao.siteCursoEvento"
                 data-vv-as="Site"
                 data-vv-name="siteCursoEvento">

          <p class="text-danger" v-show="errors.has('siteCursoEvento')">{{ errors.first('siteCursoEvento') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('instagramCursoEventoDoacao')}">
          <label class="control-label" for="instagramCursoEventoDoacao">URL Instagram</label>

          <input type="text"
                 class="form-control"
                 id="instagramCursoEventoDoacao"
                 v-model="solicitacao.instagramCursoEventoDoacao"
                 data-vv-as="Instagram"
                 data-vv-name="instagramCursoEventoDoacao">

          <p class="text-danger" v-show="errors.has('instagramCursoEventoDoacao')">{{ errors.first('instagramCursoEventoDoacao') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="mensagemFinalSalvar">
            {{labelmensagemFinalSalvar}}
          </label>

          <textarea class="form-control"
                    id="mensagemFinalSalvar"
                    v-model="solicitacao.mensagemFinalSalvar">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormConfiguracoes.vue